import { useState } from "react";
import { CalendarPlus, CalendarCheck, Calendar as CalIcon, Rss, Copy, Check } from "lucide-react";
import { googleEventUrl, downloadIcs, getCalendarFeed } from "@/lib/calendar";
import { toast } from "@/lib/toast";

// Per-appointment: add this single event to Google / Apple calendars.
export function AddToCalendar({ appt }) {
  return (
    <div className="card" data-testid="add-to-calendar">
      <h4 className="h" style={{ fontSize: 16, marginTop: 0 }}><CalendarPlus size={16} /> Add to your calendar</h4>
      <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
        <a className="btn btn-ghost btn-sm" href={googleEventUrl(appt)} target="_blank" rel="noreferrer" data-testid="cal-google">
          <CalIcon size={14} /> Google Calendar
        </a>
        <button className="btn btn-ghost btn-sm" onClick={() => downloadIcs(appt.id)} data-testid="cal-ics">
          <CalendarCheck size={14} /> Apple / Outlook (.ics)
        </button>
      </div>
    </div>
  );
}

// Per-user: subscribe once so the calendar auto-syncs all appointments.
export function CalendarSubscribe() {
  const [feed, setFeed] = useState(null);
  const [copied, setCopied] = useState(false);

  const load = async () => {
    try { setFeed(await getCalendarFeed()); }
    catch { toast("Could not load your calendar link."); }
  };

  const copy = () => {
    navigator.clipboard.writeText(feed.ics_url);
    setCopied(true); setTimeout(() => setCopied(false), 1800);
  };

  return (
    <div className="cta" style={{ marginTop: 24, background: "var(--paper)", border: "1px solid var(--line)", color: "var(--ink)" }}>
      <div>
        <h3 className="h" style={{ fontSize: 18 }}><Rss size={16} /> Sync with your calendar</h3>
        <p className="lead">Subscribe once and every appointment appears automatically in Apple or Google Calendar.</p>
        {feed && (
          <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginTop: 12 }}>
            <a className="btn btn-ink btn-sm" href={feed.webcal_url} data-testid="subscribe-apple"><CalendarCheck size={14} /> Apple Calendar</a>
            <a className="btn btn-ink btn-sm" href={feed.google_subscribe_url} target="_blank" rel="noreferrer" data-testid="subscribe-google"><CalIcon size={14} /> Google Calendar</a>
            <button className="btn btn-ghost btn-sm" onClick={copy} data-testid="subscribe-copy">{copied ? <Check size={14} /> : <Copy size={14} />} {copied ? "Copied" : "Copy link"}</button>
          </div>
        )}
      </div>
      {!feed && <button className="btn btn-ghost" onClick={load} data-testid="subscribe-open"><CalendarPlus size={15} /> Get my calendar link</button>}
    </div>
  );
}
